module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//localhost:3000/books/Xbvl2M/cover.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Pocket Guide to Combining typefaces\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Bestselling author and erstwhile musician Harper Ellison started running from his troubled past before he graduated high school. When his sister tracks him down ten years later, Harper hesitantly agrees to visit the family and small North Carolina community that rejected him when he needed them most.Life has taught Harper to avoid relationships, but he can’t seem to ignore his attraction to Lucas Rhodes, the buff, blond social worker living on his grandparents' farm. Lucas quickly becomes an anchor in the maelstrom created by Harper’s homecoming. Together they wade through the grief and loss Harper buried six-feet deep just a few miles from his childhood home.Choosing to forgive is the only way Harper will ever find peace, but can he learn that lesson before it’s too late?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Brown\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "authorURL body link",
    attrs: {
      "href": "http://monsterhousebooks.com/authors/cbauer"
    }
  }, [_vm._v("\n    \n            About Author\n       ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Five Simple Steps\n   ")]), _vm._v(" "), _c('a', {
    staticClass: "publisherURL body link",
    attrs: {
      "href": "http://www.monsterhousebooks.com"
    }
  }, [_vm._v("\n\n        About Publisher\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 25
// module chunks = 0